import React, { useState } from 'react';
import '../style/base.css';
import '../style/navbar.css';
import '../style/pages.css';
import '../style/responsive.css';
import '../style/sidebar.css';
import content from '../content.json';

const Sidebar = () => {
  const [isActive, setIsActive] = useState(false);
  const { sidebar } = content;

  const startYear = 2017;
  const currentYear = new Date().getFullYear();
  const yearsOfExperience = currentYear - startYear;

  const toggleSidebar = () => {
    setIsActive(!isActive);
  };

  return (
    <aside className={`sidebar ${isActive ? 'active' : ''}`} data-sidebar>
      <div className="sidebar-info">
        <figure className="avatar-box">
        <img src="/images/RRRAvatar.png" alt={sidebar.name} width="80" />
        </figure>

        <div className="info-content">
          <h1 className="name" title={sidebar.name}>{sidebar.name}</h1>
          <div className="exp-content">
            <div>
              <strong>Years of Experience</strong>
              <span className="exp-number">{yearsOfExperience}+</span>
            </div>
            <p className="exp-update-text">(updates every year)</p>
          </div>
          <div className="title-scroll spacing-10">
            <p className="title">{sidebar.title}</p>
            <p className="title">{sidebar.title}</p>
          </div>
          
        </div>

        <button className="info_more-btn" onClick={toggleSidebar}>
          <span>{isActive ? sidebar.buttons.hide : sidebar.buttons.show}</span>
          <ion-icon name={`chevron-${isActive ? 'up' : 'down'}`}></ion-icon>
        </button>
      </div>

      <div className="separator"></div>

      <div className="sidebar-info_more">
        <ul className="contacts-list">
          <li className="contact-item">
            <div className="icon-box">
              <ion-icon name="mail-outline"></ion-icon>
            </div>
            <div className="contact-info">
              <p className="contact-title">{sidebar.contacts.email.title}</p>
              <a href={sidebar.contacts.email.link} className="contact-link">{sidebar.contacts.email.value}</a>
            </div>
          </li>

          <li className="contact-item">
            <div className="icon-box">
              <ion-icon name="phone-portrait-outline"></ion-icon>
            </div>
            <div className="contact-info">
              <p className="contact-title">{sidebar.contacts.phone.title}</p>
              <a href={sidebar.contacts.phone.link} className="contact-link">{sidebar.contacts.phone.value}</a>
            </div>
          </li>

          <li className="contact-item">
            <div className="icon-box">
              <ion-icon name="location-outline"></ion-icon>
            </div>
            <div className="contact-info">
              <p className="contact-title">{sidebar.contacts.location.title}</p>
              <address>{sidebar.contacts.location.value}</address>
            </div>
          </li>
        </ul>

        <div className="separator"></div>

        <ul className="social-list">
          {sidebar.social.map((platform, index) => (
            <li key={index} className="social-item">
              <a href={platform.url} className="social-link">
                <ion-icon name={`logo-${platform.name}`}></ion-icon>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
